export default __webpack_public_path__ + "static/media/lotus-contours.8bab9e17.svg";